import { TranslateService } from '@ngx-translate/core';
import { HighChartDataBase } from './high-chart-data-base';
import * as Highcharts from "highcharts";
import { ChartSerie } from './chart-serie';
import { ClickDataPoint, ClickNotifier } from './click-notifier';

//import 'highcharts/modules/exporting';
//require("highcharts/highcharts-more.js")(Highcharts);

export class BoxPlotHighChartData extends HighChartDataBase {

    constructor(
        protected override translate: TranslateService,
        protected override jsonData?: any,
        protected override width?: any,
        protected override height?: any,
        protected override clickNotifier?: ClickNotifier) {
        super(translate, jsonData, width, height, clickNotifier);
    }

    // Format BoxPlot ChartSeries
    // Alltid 5 kolumner med data i boxplot
    private formatBoxPlotChartSeries(): void {
        let chartSerie = new ChartSerie();
        chartSerie.data = [];
        this.chartSeries.forEach(serie => {
            let dataItems: any[] = [];
            serie.data.forEach(dataItem => {
                dataItems.push(dataItem.y);
            });
            dataItems.sort(this.sortNumber);

            // Om det är DBNULL = 0 i db, ändra värdet till samma som median-värdet på index-plats 2.
            for (let i = 0; i < 5; i++) {
                if (dataItems[i] == null) {
                    dataItems[i] = dataItems[2];
                }
            }
            chartSerie.data.push(dataItems);
        });
        this.chartSeries = [chartSerie];
    }

    public getHighChartOptions(): Object {
        this.formatBoxPlotChartSeries();
        let that = this;
        return {
            accessability: { enabled: false },
            chart: {
                type: 'boxplot',
                height: this.chartHeight,
                zoomType: 'x',
                resetZoomButton: {
                    position: { x: 0, y: -45 }
                },
                panning: true,
                panKey: 'shift'
            },
            title: {
                text: this.chartTitle,
                widthAdjust: -150,
                margin: 30
            },
            subtitle: {
                text: this.chartSubTitle ,
                widthAdjust: -150
            },
            legend: {
                enabled: false
            },
            yAxis: this.getYAxis(),
            series: this.chartSeries,
            xAxis: {
                type: "category",
                categories: this.categories,
                title: {
                    text: this.xAxisTitle
                },
                labels: {
                    step: (document.getElementById("chart-wrapper") ? (document.getElementById("chart-wrapper").clientWidth > 750 ? (this.categories.length < 100 ? 1 : null) : null) : null),
                    rotation: this.xAxisLabelRotation,
                    style: {
                        fontSize: this.categories.length > 50 && this.categories.length < 100 ? '10px' : '11px'
                    },
                    formatter: function () {
                        for (var i = 0; i < that.categories.length; i++) {
                            if (that.categories[i] === this.value) {
                                if (that.xAxisColors && that.xAxisColors[i] != '')
                                    return '<span style="fill: ' + that.xAxisColors[i] + ';">' + this.value + '</span>';
                                else
                                    return this.value;
                            }
                        }
                    }
                },
                min: Number.isNaN(this.xMinValue) ? null : this.xMinValue,
                max: Number.isNaN(this.xMaxValue) ? null : this.xMaxValue
            },
            plotOptions: {
                boxplot: {
                    pointPadding: 0.1,
                    point: {
                        events: {
                            click: function () {
                                if (this.clickNotifier) {
                                    that.clickNotifier.handleClick(new ClickDataPoint(this.category, this.series.name, this.y));
                                }
                            }
                        }
                    },
                    tooltip: {
                        useHTML: true,
                        headerFormat: '<u style="font-size:11px">{point.key}</u><br>',
                        pointFormat: '<span>'+ this.translate.instant('xml-report.table.boxplot.maximum') +': </span><b>{point.high}</b><br>' +
                                '<span>'+ this.translate.instant('xml-report.table.boxplot.upperQuartile') +': </span><b>{point.q3}</b><br>' +
                                '<span>'+ this.translate.instant('xml-report.table.boxplot.median') +': </span><b>{point.median}</b><br>' +
                                '<span>'+ this.translate.instant('xml-report.table.boxplot.lowerQuartile') +': </span><b>{point.q1}</b><br>' +
                                '<span>'+ this.translate.instant('xml-report.table.boxplot.minimum') +': </span><b>{point.low}</b><br>'
                    },
                    lineWidth: 1,
                    medianWidth: 1,
                    whiskerLength: '60%',
                    whiskerWidth: 1
                }
            },
            colors: this.defaultColors,
            credits: {
                text: this.credits,
                href: this.creditsLink
            },

            responsive: {
                rules: [{
                    condition: {
                        maxWidth: this.chartWidth
                    }
                }]
            },

            exporting: {
                filename: "diagram_" + this.chartTitle
            }
        };
    }

    /**
     * Sort array by number instead of alphabetically,
     * use: array.sort(sortNumber)
     * @param a
     * @param b
     */
    sortNumber(a, b): number {
        return a - b;
    }

    /**
     * Hämta Y-axlar
     */
    private getYAxis() {
        let firstYAxis = this.createYAxis(this.yAxisTitle, this.yAxisTitleColor, this.yMinValue, this.yMaxValue);
        if (!this.hasY2Axis) {
            //Om det endast finns en y-axis
            return firstYAxis;
        }
        else {
            // Om det finns två y-axlar
            let yAxis = [];
            yAxis.push(firstYAxis);
            let secondYAxis = this.createYAxis(this.y2AxisTitle, this.y2AxisTitleColor, this.y2MinValue, this.y2MaxValue, true);
            yAxis.push(secondYAxis);
            return yAxis;
        }
    }

}
